module.exports = __webpack_public_path__ + "static/media/GraphikMedium.4a127c95.otf";